import {createAction} from '@reduxjs/toolkit'
import {ScheduleItem} from '../types'

export const toggleFiltersModal = createAction<void>('TOGGLE_FILTERS_MODAL')
export const toggleScheduleItemModal = createAction<ScheduleItem>('TOGGLE_SCHEDULE_ITEM_MODAL')

export type ToggleScheduleItemModal = typeof toggleScheduleItemModal
export type ToggleFiltersModal = typeof toggleFiltersModal
